
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";
import { setAlert } from "./alert.slice";
import { BASE_URL } from "../../utils/baseURL";
import Cookies from 'js-cookie';

const initialState = {
    assignInstaller: [],
    liasonings: [],
    Fabricator: [],
    Electrician: [],
    Technician: [],
    assignuser: [],
    success: false,
    message: '',
    loading: false,
    userStats: false
};

const handleErrors = (error, dispatch, rejectWithValue) => {
    const errorMessage = error.response?.data?.message || 'An error occurred';
    dispatch(setAlert({ text: errorMessage, color: 'error' }));
    return rejectWithValue(error.response?.data || { message: errorMessage });
};

export const getAssignInstaller = createAsyncThunk(
    'assignInstaller/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getAllAssignInstaller', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            console.log(response.data, " cdcd");
            return response.data;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const addAssignInstaller = createAsyncThunk(
    'assignInstaller/add',
    async (data, { dispatch, rejectWithValue }) => {
        console.log("data", data);
        try {
            const response = await axiosInstance.post(BASE_URL + '/createAssignInstaller', data, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            // console.log("response", response.data);
            dispatch(getAssignInstaller());
            return response.data.assignInstaller;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const deleteAssignInstaller = createAsyncThunk(
    'assignInstaller/delete',
    async (id, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.delete(BASE_URL + `/deleteAssignInstaller/${id}`, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            return id;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const editAssignInstaller = createAsyncThunk(
    'assignInstaller/edit',
    async (data, { dispatch, rejectWithValue }) => {
        console.log("data", data);
        try {
            const { _id, ...rest } = data;
            const response = await axiosInstance.put(BASE_URL + `/updateAssignInstaller/${_id}`, rest, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            // console.log(response.data);
            dispatch(getAssignInstaller());
            return response.data.assignInstaller;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getliasoning = createAsyncThunk(
    'getliasoning/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getLiaoningsdata', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.liasonings;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getFabricator = createAsyncThunk(
    'getFabricator/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getFabricator', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.Fabricator;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);
export const getElectrician = createAsyncThunk(
    'getElectrician/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getElectrician', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.Electrician;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);
export const getTechnician = createAsyncThunk(
    'getTechnician/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getTechnician', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            // console.log("response.data", response.data);
            return response.data.Technician;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);
export const getassignuser = createAsyncThunk(
    'assignuser/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getUserinAssign', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            // console.log("response.data", response.data);
            return response.data.assignuser;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

const assignInstallerSlice = createSlice({
    name: 'assignInstaller',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Get Assign Installer
            .addCase(getAssignInstaller.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching assignInstaller...';
            })
            .addCase(getAssignInstaller.fulfilled, (state, action) => {
                console.log("action============", action.payload);
                state.loading = false;
                state.success = true;
                state.message = action.payload?.message || 'Assign Installer fetched successfully';
                state.assignInstaller = action.payload.assignInstaller;
                state.userStats = action.payload.userStatus
            })
            .addCase(getAssignInstaller.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
            })
            // Add Assign Installer
            .addCase(addAssignInstaller.pending, (state) => {
                state.loading = true;
                state.message = 'Adding assignInstaller...';
            })
            .addCase(addAssignInstaller.fulfilled, (state, action) => {
                console.log("action", action);
                state.loading = false;
                state.success = true;
                state.assignInstaller.push(action.payload);
                state.message = action.payload?.message || 'Assign Installer added successfully';
                // if (Array.isArray(state.assignInstaller)) {
                //     state.assignInstaller.push(action.payload);
                // } else {
                //     state.assignInstaller = [action.payload];
                // }
                // state.message = action.payload?.message || 'Assign Installer added successfully';
            })
            .addCase(addAssignInstaller.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to add assignInstaller';
            })
            // Delete Assign Installer
            .addCase(deleteAssignInstaller.pending, (state) => {
                state.loading = true;
                state.message = 'Deleting assignInstaller...';
            })
            .addCase(deleteAssignInstaller.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.assignInstaller = state.assignInstaller.filter((v) => v._id !== action.payload);
                state.message = action.payload?.message || 'Assign Installer deleted successfully';
            })
            .addCase(deleteAssignInstaller.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to delete assignInstaller';
            })
            // Edit Assign Installer
            .addCase(editAssignInstaller.pending, (state) => {
                state.loading = true;
                state.message = 'Editing assignInstaller...';
            })
            .addCase(editAssignInstaller.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.assignInstaller = state.assignInstaller.map((v) =>
                    v._id === action.payload._id ? action.payload : v
                );
                state.message = action.payload?.message || 'Assign Installer updated successfully';
            })
            .addCase(editAssignInstaller.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to update assignInstaller';
            })
            // Get Liasoning
            .addCase(getliasoning.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching assignInstaller...';
            })
            .addCase(getliasoning.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.liasonings = action.payload;
                state.message = action.payload?.message || 'Assign Installer fetched successfully';
            })
            .addCase(getliasoning.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
            })
            // Get Fabricator
            .addCase(getFabricator.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching assignInstaller...';
            })
            .addCase(getFabricator.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.Fabricator = action.payload;
                state.message = action.payload?.message || 'Assign Installer fetched successfully';
            })
            .addCase(getFabricator.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
            })
            // Get Electrician
            .addCase(getElectrician.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching assignInstaller...';
            })
            .addCase(getElectrician.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.Electrician = action.payload;
                state.message = action.payload?.message || 'Assign Installer fetched successfully';
            })
            .addCase(getElectrician.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
            })
            // Get Technician
            .addCase(getTechnician.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching assignInstaller...';
            })
            .addCase(getTechnician.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.Technician = action.payload;
                state.message = action.payload?.message || 'Assign Installer fetched successfully';
            })
            .addCase(getTechnician.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
            })
            // Get assignuser
            .addCase(getassignuser.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching assignInstaller...';
            })
            .addCase(getassignuser.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.assignuser = action.payload;
                state.message = action.payload?.message || 'Assign Installer fetched successfully';
            })
            .addCase(getassignuser.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
            })
    }
});

export default assignInstallerSlice.reducer;